module.exports = __webpack_public_path__ + "img/sidebar-toggle-off_hover.c58e1a1c.svg";